import * as React from "react";
import * as P230Messages from "../../../misc/api/DeviceLinkApi/P230In2itiveMessages";
import { StudyScheduleSession } from "webportalclient";
import { Subject } from "../../../misc/api/apiTypes";
import { useWebPortalApiClient, useWebPortalLegacyClient } from "../../../misc/api/WebPortalTokenClient";
import LoadingWithMessage from "../../../misc/components/LoadingWithMessage";
import { ConfigureP230Device, ConfigureP230HomeSpirometrySession } from "./P230HomeSpirometryConfiguration";
import { useCurrentStudyConfigurationContext } from "../../../Core/CurrentStudyConfigurationContext";
import { Device } from "../../../misc/api/DeviceLinkApi/Devices";
import { useAboutContextProvider } from "../../../Core/AboutContextProvider";

interface P230HomeSpirometryLocalConfigureProps {
    subject: Subject;
    deviceSelected: Device;
    sessionScheduleItems: StudyScheduleSession[];
    onError: (message: string) => void;
    onComplete: (redirect?: string) => void;
}

export const P230HomeSpirometryLocalConfigure = ({ subject, deviceSelected, sessionScheduleItems, onError, onComplete }: P230HomeSpirometryLocalConfigureProps) => {
    const client = useWebPortalApiClient();
    const [status, setStatus] = React.useState(P230Messages.ConfiguringDevice);
    const { study } = useCurrentStudyConfigurationContext();
    const legacyClient = useWebPortalLegacyClient();
    const { about } = useAboutContextProvider();

    React.useEffect(() => {
        const localConfigure = async () => {
            const result = await ConfigureP230Device(client.client, legacyClient, study, subject, deviceSelected, sessionScheduleItems, about.UpdateServiceUri, setStatus, onError);

            if (result === false)
                return;

            const actions = await client.client.getStudyScheduleSessionActions(`actionType,studyScheduleSessionId`, `studyScheduleSessionId eq ${sessionScheduleItems[0].id}`);

            const createSession = actions.value.map(a => a.actionType).includes(6); // Supervised Home Spirometry

            setStatus(P230Messages.StartingHomeSpirometrySession);
            const analysisSetResult = await ConfigureP230HomeSpirometrySession(client.client, deviceSelected.serial, subject, sessionScheduleItems[0], createSession);

            
            if (createSession) {  // Supervised Home Spirometry
                onComplete(`/spirometry/siteAnalysis/${analysisSetResult.id}/edit`);
            } else {
                onComplete();
            }

            
        }

        localConfigure();
    }, []);

    return (
        <div className="modal-body">
            <LoadingWithMessage message={status} />
        </div>
    );
}
